__turbopack_context__.v({
  "faqs-category-list": "FaqCategories-module-scss-module__oH0RyG__faqs-category-list",
});
